import React from 'react';
import { notification } from 'antd/lib';
import { Form } from '@ant-design/compatible';
import { graphql, compose, withApollo } from 'react-apollo';
import Loading from '../../common/Loading';

import FormDeposito from './formDeposito';

import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import insertDeposito from '../../../graphql/mutations/venta/insertDeposito.graphql';

@compose(
  graphql(getUsuario),
  graphql(insertDeposito, {
    name: 'insertDeposito',
  })
)
class CargarDeposito extends React.Component {
  onSubmit = e => {
    e.preventDefault();
  };

  crearDeposito = deposito => {
    this.props
      .insertDeposito({
        variables: { objDeposito: deposito },
      })
      // eslint-disable-next-line no-unused-vars
      .then(res => {
        notification.success({
          message: 'Deposito Registrado',
          description:
            'El deposito se registró correctamente en la base de datos',
        });

        this.props.history.push('/');
      })
      .catch(err => {
        console.log('Se ha producido un error');
        console.log(err);
        notification.error({
          message: 'Error al registrar el deposito',
          description: 'Se ha producido un error al registrar el deposito',
        });
      });
  };

  render() {
    const { data } = this.props;
    if (data.loading) {
      return <Loading />;
    }

    if (!data.getUsuario) {
      return null;
    }

    return (
      <div>
        <h1 className="tituloForm">Administración General</h1>

        <FormDeposito onSubmit={this.crearDeposito} />
      </div>
    );
  }
}

export default Form.create()(withApollo(CargarDeposito));
